import httpClient from './http-client';

const endpoint = 'api/images';

const imageService = {
  getImages: (params) => httpClient.get(endpoint, { params }),

  reorderImages: (payload) => httpClient.post('api/images-reorder', payload),

  upload: (images, type, modelType, modelId) => {
    const formData = new FormData();
    for (let i = 0; i < images.length; i++) {
      formData.append('images[]', images[i]);
    }
    formData.append('type', type);
    if (modelType) {
      formData.append('model_type', modelType);
    }
    if (modelId) {
      formData.append('model_id', modelId);
    }
    return httpClient.post(`${endpoint}`, formData);
  },

  delete: (image) => httpClient.delete(`${endpoint}/${image.id}`),
};

export default imageService;
